export type AdminTab = "bookings" | "challenges" | "invitations" | "settings";
export type AdminNotificationKind = "booking" | "challenge";

export interface AdminNotificationEvent {
  id: string;
  kind: AdminNotificationKind;
  occurredAt?: string;
}

export const ADMIN_NOTIFICATION_CHANNEL = "admin-notifications";
export const ADMIN_NOTIFICATION_PREFERENCE_KEY = "mathe-mit-joe:admin-notifications";

function record(value: unknown): Record<string, unknown> | undefined {
  return value && typeof value === "object" ? value as Record<string, unknown> : undefined;
}

export function parseAdminBroadcast(event: string, message: unknown): AdminNotificationEvent | undefined {
  const envelope = record(message);
  const payload = record(envelope?.payload) ?? envelope;
  const id = payload?.id;
  if (typeof id !== "string" || !id || id.length > 100) return undefined;

  const kind = event === "booking-created"
    ? "booking"
    : event === "challenge-created"
      ? "challenge"
      : undefined;
  if (!kind) return undefined;

  return {
    id,
    kind,
    occurredAt: typeof payload?.occurredAt === "string" ? payload.occurredAt : undefined,
  };
}

export function adminTabFromSearch(search: string): AdminTab {
  const value = new URLSearchParams(search).get("tab");
  return value === "challenges" || value === "invitations" || value === "settings" ? value : "bookings";
}

export function adminNotificationCopy(kind: AdminNotificationKind) {
  return kind === "booking"
    ? {
        title: "Neue Terminanfrage",
        body: "Eine neue Anfrage für eine Probestunde ist eingegangen.",
        message: "Neue Terminanfrage eingegangen.",
        tab: "bookings" as const,
      }
    : {
        title: "Neue Mathe-Challenge",
        body: "Eine neue Aufgabe wurde sicher hochgeladen.",
        message: "Neue Mathe-Challenge eingegangen.",
        tab: "challenges" as const,
      };
}

export function adminNotificationUrl(kind: AdminNotificationKind, origin: string) {
  const copy = adminNotificationCopy(kind);
  const url = new URL("/", origin);
  url.searchParams.set("view", "admin");
  url.searchParams.set("tab", copy.tab);
  return url.toString();
}
